<template>
  <div class="com_card">
    <div class="com_card_title">
      <div class="title">{{title}}</div>
      <div class="more" @click="moreHandle" v-show="showMore">更多</div>
      <div class="more data_message" @click="dataHandle" v-show="showData">
        <i class="iconfont" style="margin-right:4px;">&#xe803;</i>
        <span>数据说明</span>
      </div>
    </div>
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    title:{
      type:String,
      default:""
    },
    showMore:{
      type:Boolean,
      default:true
    },
    showData:{
      type:Boolean,
      default:false
    }
  },
  methods:{
    moreHandle() {
      this.$emit('moreHandle')
    },
    dataHandle() {
      this.$emit('dataHandle')
    }
  }
}
</script>

<style lang="less" scoped>
.com_card{
  width:100%;
  position: relative;
  background: #ffffff;
  .com_card_title{
    width: 100%;
    height: 0.43rem;
    display: flex;
    align-items: center;
    padding-left: 0.29rem;
    padding-right: 0.13rem;
    position: relative;
    &::before{
      content: '';
      background: #FE7922;
      position: absolute;
      top: 12px;
      left: 16px;
      width: 6px;
      height: 40px;
      transform: scale(.5);
      transform-origin: 0 0;
      pointer-events: none;
      box-sizing: border-box;
      border: 0 solid #e9eaec;
      border-bottom-width: 1px;
    }
    .title{
      display: flex;
      align-items: center;
      flex: 1;
      font-size:20px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(51,51,51,1);
      line-height:28px;
    }
    .more{
      font-size:14px;
      font-family:MicrosoftYaHeiUI;
      color:rgba(153,153,153,1);
      line-height:18px;
    }
    .data_message{
      width:77px;
      height:20px;
      position: absolute;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 0.08rem;
      background:rgba(248,248,248,1);
      border-radius:100px 0px 0px 100px;
      font-size: 12px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(153,153,153,1);
      line-height:17px;
    }
  }
}
</style>